import type { TRuleWithTheme } from '@/styles/theme';

export const message: TRuleWithTheme = ({ theme }) => ({
    '&.ant-alert': {
        marginBottom: 0,
        width: '100%',
    },
});
